<template>
  <div class="row">
    <div class="mx-auto col-md-12">
      <div class="card p-3 mb-3">
        <div class="card-body">
          <b-card class="mb-3" header="Relatório Status Pagamento">
            <b-row>
              <b-col class="col-2">
                <b-form-group label="Ano" label-size="sm">
                  <b-form-input
                    id="ano"
                    autocomplete="off"
                    v-model="filtro.ano"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="col-3">
                <b-form-group label="Mês" label-size="sm">
                  <b-form-select id="mes" :options="meses" v-model="filtro.mes">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Status" label-size="sm">
                  <b-form-select
                    id="status"
                    :options="listaStatusPagamento"
                    v-model="filtro.status_pagamento"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col class="text-right">
                <b-button variant="primary" @click="listar">
                  <font-awesome-icon :icon="['fas', 'search']" /> Pesquisar
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <div class="card p-3 mb-3">
            <div class="card-body">
              <b-card no-body>
                <b-card-header size="sm">
                  <div class="float-right">
                    <b-button
                      variant="primary"
                      :disabled="tabela.items.length == 0"
                      @click.prevent="gerarRelatorio"
                      title="Gerar Relatório"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'file-pdf']"
                        title="Gerar Relatório"
                        class="mr-1"
                      />
                      Gerar Relatório
                    </b-button>
                  </div>
                </b-card-header>
                <b-table
                  no-provider-paging
                  small
                  responsive
                  bordered
                  :empty-text="tabela.emptyText"
                  :fields="tabela.fields"
                  :items="tabela.items"
                  :show-empty="tabela.showEmpty"
                  :striped="tabela.striped"
                >
                  <template v-slot:cell(data_nascimento)="data">
                    {{ $helpers.formatDateHourToDate(data.value) }}
                  </template>
                  <template v-slot:cell(ind_ativo)="data">
                    <b-badge v-if="data.value == 'A'" variant="success"
                      >Ativo</b-badge
                    >
                    <b-badge v-else-if="data.value == 'I'" variant="danger"
                      >Inativo</b-badge
                    >
                  </template>
                  <template v-slot:cell(valor_beneficio)="data">
                    {{ $helpers.formatReal(data.value) }}
                  </template>
                </b-table>
                <b-card-footer size="sm">
                  <div class="float-left">
                    <b-input-group prepend="Quantidade de Registros">
                      <b-input disabled v-model="tabela.totalRows"></b-input>
                    </b-input-group>
                  </div>
                  <div class="float-right">
                    <b-pagination
                      align="right"
                      :total-rows="tabela.totalRows"
                      v-model="tabela.currentPage"
                      :per-page="tabela.perPage"
                      @change="changePaginacao"
                    >
                    </b-pagination>
                  </div>
                </b-card-footer>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { meses } from "../../../helpers";
import moment from "moment";

export default {
  data() {
    return {
      filtro: {
        mes: moment().format("MM"),
        ano: moment().format("YYYY"),
        status_pagamento: null,
      },
      meses: [{ text: "", value: null }, ...meses],
      listaStatusPagamento: [],
      tabela: {
        items: [],
        fields: [
          {
            key: "mes_ano_referencia",
            label: "Mês/Ano Referência",
            class: "text-center",
          },
          {
            key: "cpf_requerente",
            label: "CPF",
            class: "text-center",
          },
          {
            key: "nome_completo",
            label: "Nome completo",
            class: "text-center",
          },
          {
            key: "nome_mae",
            label: "Nome da mãe",
            class: "text-center",
          },
          {
            key: "data_nascimento",
            label: "Data Nascimento",
            class: "text-center",
          },
          {
            key: "valor_beneficio",
            label: "Valor Benefício",
            class: "text-center",
          },
          {
            key: "descricao_status_pagamento",
            label: "Status Pagamento",
            class: "text-center",
          },
          {
            key: "ind_ativo",
            label: "Situação",
            class: "text-center",
          },
        ],
        showEmpty: true,
        emptyText: "Nenhum registro encontrado",
        striped: true,
        perPage: 10,
        totalRows: 0,
        currentPage: 1,
      },
    };
  },

  methods: {
    changePaginacao() {
      this.listar();
    },

    listarStatusPagamento() {
      this.$api
        .get(`status-pagamento/`)
        .then((response) => {
          if (response.status == 200) {
            response.data.dados.forEach((element) => {
              element.value = element.id;
              element.text = element.descricao_status_pagamento;
              this.listaStatusPagamento.push(element);
            });
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },

    listar() {
      this.$api
        .get(`pagamentos/situacao-dados-pagamento`, { params: this.filtro })
        .then((response) => {
          if (response.status == 200) {
            this.tabela.items = response.data.dados;
            this.tabela.totalRows = response.data.dados.length;
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },

    gerarRelatorio() {
      this.$api
        .get(`pagamentos/relatorio/situacao-pagamento`, {
          responseType: "blob",
        })
        .then((response) => {
          this.$helpers.downloadFile(response.data, "situacao_pagamento.xlsx");
          this.$helpers.showToast(
            this,
            "Sucesso",
            "Relatório gerado com sucesso.",
            "success"
          );
        })
        .catch(() => {
          this.$helpers.showToast(
            this,
            "Erro",
            "Erro na geração do relatório",
            "danger"
          );
        });
    },
  },

  mounted() {
    this.listarStatusPagamento();
    this.listar();
  },
};
</script>

<style scoped>
</style>
